import React from "react";
import SectionPage from "@/components/SectionPage";

export default function Motivations() {
  return <SectionPage sectionKey="motivations" />;
}
